import { css } from "@emotion/react";

import * as dimensions from "@styles/emotion-styles/dimensions";

export const headerSpacer = css`
  height: 2rem;

  @media (max-width: ${dimensions.phoneLargeMax}) {
    height: 0;
  }
`;
